export default "__VITE_ASSET__ec5b4e45__"